export const variantDisplayName = process.env.REACT_APP_VARIANT_DISPLAY_NAME
export const variantDisplayNameArticle =
  process.env.REACT_APP_VARIANT_DISPLAY_NAME_ARTICLE
export const variantLandingPageUrl =
  process.env.REACT_APP_VARIANT_LANDING_PAGE_URL
export const variantOngoingPeriod = process.env.REACT_APP_VARIANT_ONGOING_PERIOD
export const variantPrefix = process.env.REACT_APP_VARIANT_PREFIX
